import { useSelector } from 'core/use-cases/utilities';

import type { RootState } from 'core/store';

/**
 * Selectors the value of a property through its name
 *
 */
export function useAppSelectors<T extends keyof RootState['app']>(key: T) {
  const value = useSelector<RootState['app'][T]>((state) => state.app[key]);

  return value;
}
